import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import Sorting from "@tunnel-components/@sharded/sorting/component";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as Paths from "@tunnel-enums/index";
import VirtualPagination from "@tunnel-components/@sharded/@widgets/virtualized/pagination";
import VirtualLoader from "@tunnel-components/@sharded/@widgets/virtual-loader/component";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import ExplorerIncidents from "@tunnel-components/@sharded/widgets/box/explorer/incident/component";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
// import * as shortid from "shortid";
import * as i18next from "i18next";
// import { stringify } from 'querystring';

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */

const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    totalElements,
    itemsPerPage,
    errorSearchIncident,
    actionloading,
    paramArray,
    noIncidents,
    onUpdateCurrentPageNumber,
    currentPageNumbers,
    onIncidentActif,
    onExtractImpact,
    onExtractVideo,
    errorExtractionVideo,
    errorExtractionPdf,
    loading,
    errorserver,
    explorerData,
    onSortingBy,
    /*startTimeOver,sectionOver,*/ arrayOfIncident,
    onClose,
    onOpen,
    filterHeader,
    filter,
    /* onTextOver,alarmOver,*/ onDeletedSimulation,
    onpensearchboolean,
    explorersearch,
    onExplorerSearch,
    onExplorerSearchChange,
    onPenSearchIncidentsClose,
    onClearIncidentSearch,
    onPenSearchIncidents,
    onOpenhoverCard,
    openHoverCard,
    onClosehoverCard,
    onReset,
    selectedValueName,
    onGetValue,
    endDate,
    QualificationState,
    onSearchQualification,
    qualification,
    onEndDateChange,
    startDate,
    onStartDateChange,
    isFilter,
    onFilter,
    errorDateRange,
    section,
    cameraList,
    incidentTypeList,
    cameraFilter,
    sectionFilter,
    labelFilter,
    onSearchFilterCamera,
    onSearchFilterLabel,
    onSearchFilterSection,
    onSearchSubmitFilter,
    onUpdateScrollTop,
  } = props;

  const User: any = Utils.createdUserRoles();
  const SYSTEMVIEWTUBES: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
  ]);

  /**
   * @description : le tableua relatif
   * à la position de l'incidents
   * @const
   * @name dataCar
   * @type { strin[]  }
   */
  const dataCar: string[] = [
    i18next.t("voie de gauche"),
    i18next.t("voie de droite"),
    i18next.t("parking"),
    i18next.t("bau"),
    i18next.t("trottoir"),
  ];
  /**
   * @description : retourne un tableau de type string ( )
   * @const
   * @name csvData
   * @type { any []  }
   */
  const csvData: any =
    !!explorerData &&
    Utils.cloneObjectOrArray(explorerData)
      .filter((elem: any) => delete elem.finished)
      .map((element: any) => {
        element.tube = element.camera && element.camera.section.name;
        element.vehiclePosition = dataCar[Number(element.vehiclePosition)];
        element.camera = element.camera.code;

        element.qualificationTime = element.qualified
          ? element.qualificationTime
          : null;
        return element;
      });
  /**
   * @description : retourne un tableau
   * @const
   * @name sectionSearch
   * @type { any  }
   */
  const sectionSearch: any[] = Utils.createAnUniqueArrayFromCameraObject(
    section,
    "section"
  );

  /**
   * @description : retourne un tableau
   * @const
   * @name labelSearch
   * @type { any  }
   */
  const labelSearch: any[] =
    incidentTypeList &&
    Utils.createAnUniqueArrayFromCameraObject(incidentTypeList, "label");

  /**
   * @description : retourne un tableau
   * @const
   * @name cameraSearch
   * @type { any  }
   */
  const cameraSearch: any[] =
    cameraList &&
    Utils.createAnUniqueArrayFromCameraObject(cameraList, "camera");

  /**
   * a callback method to define yourself depending on what you want
   * to do with your data. This method is the core of your list,
   * it is here that you define what will be rendered thanks to your data
   */
  const rowRenderer = ({ index, key, style }: any): JSX.Element => {
    /**
     * @constant
     * @description :
     * @name  items
     * @types any[]
     */
    const items: any[] = [];
    /**
     * @constant
     * @description :
     * @name  fromIndex
     * @types number
     */
    const fromIndex: number = index;
    /**
     * @constant
     * @description :
     * @name  toIndex
     * @types number
     */
    const toIndex: number = Math.min(fromIndex + 1, explorerData.length);
    {
      /** Boucle */
    }
    for (let i = fromIndex; i < toIndex; i++) {
      {
        /** Création du tableau des items */
      }

      items.push(
        <ExplorerIncidents
          classnameIncident="incidentTable"
          Elem={!!explorerData[i] && explorerData[i]}
          key={key && key}
          arrayOfIncident={!!arrayOfIncident[i] && arrayOfIncident[i]}
          incident={!!arrayOfIncident[i] && arrayOfIncident[i]}
          // onFalseAlert={onTextOver(i,"alarm")}
          // falseAlert={alarmOver[i]}
          // startTimeAction={startTimeOver[i]}
          // onCameraSectionName={onTextOver(i,"section")}
          // cameraSection={sectionOver[i]}
          // onStartTimeAction={onTextOver(i,"date")}
          onActive={onIncidentActif(i)}
          onExtractImpact={onExtractImpact(
            !!explorerData[i] && explorerData[i].id,
            i
          )}
          onExtractVideo={onExtractVideo(
            !!explorerData[i] && explorerData[i],
            i
          )}
          onDeletedSimulation={onDeletedSimulation(
            !!explorerData[i] && explorerData[i].id
          )}
        />
      );
    }
    /**
     * @description:
     */
    return (
      <div
        key={key}
        style={{
          ...style,
          width: "100%",
        }}
      >
        {items}
      </div>
    );
  };

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      // Box infos
      // arrayOfIncident={true}
      placeholdersearch={i18next.t("rechercher de l incident par Identifiant")}
      arrayOfIncident={
        !!arrayOfIncident[Number(paramArray)] &&
        arrayOfIncident[Number(paramArray)]
      }
      onExtractImpact={onExtractImpact(
        !!explorerData[Number(paramArray)] &&
          explorerData[Number(paramArray)].id,
        Number(paramArray)
      )}
      onExtractVideo={onExtractVideo(
        !!explorerData[Number(paramArray)] && explorerData[Number(paramArray)],
        Number(paramArray)
      )}
      onActive={onIncidentActif(Number(paramArray))}
      explorerData={
        !!explorerData &&
        !!explorerData[Number(paramArray)] &&
        explorerData[Number(paramArray)]
      }
      actionloading={actionloading}
      // End box infos
      loading={loading}
      onPenSearchIncidents={onPenSearchIncidentsClose}
      onpensearchboolean={onpensearchboolean}
      explorersearch={explorersearch}
      onExplorerSearch={onExplorerSearch}
      onExplorerSearchChange={onExplorerSearchChange}
      someTextError={i18next.t("impossible d'extraire la séquence")}
      snackbarError={errorExtractionVideo}
      error={errorserver}
      selectedValueName={selectedValueName}
      onGetValue={onGetValue}
      endDate={endDate}
      QualificationState={QualificationState}
      onSearchQualification={onSearchQualification}
      qualification={qualification}
      onEndDateChange={onEndDateChange}
      startDate={startDate}
      onStartDateChange={onStartDateChange}
      isFilter={isFilter}
      onClose={onFilter}
      errorDateRange={errorDateRange}
      section={sectionSearch}
      cameras={cameraSearch}
      label={labelSearch}
      cameraFilter={cameraFilter}
      sectionFilter={sectionFilter}
      labelFilter={labelFilter}
      onSearchFilterCamera={onSearchFilterCamera}
      onSearchFilterLabel={onSearchFilterLabel}
      onSearchFilterSection={onSearchFilterSection}
      onSearchSubmitFilter={onSearchSubmitFilter}
    >
      <section className="tunnel-site animated fadeIn">
        {!Lodash.isEmpty(explorerData) && !!explorerData && (
          <BreadCrumb
            width="26"
            height="26"
            iconExplorer={true}
            bulles={explorersearch}
            onClearIncidentSearch={onClearIncidentSearch}
            links={Paths.PathsNamesEnums.EXPLORE}
            title={i18next.t("explorer")}
            breadText1={i18next.t("incidents")}
            filtreHistory={true}
            onPenSearchIncidents={onPenSearchIncidents}
            csvData={csvData}
            onOpenhoverCard={onOpenhoverCard}
            openHoverCard={openHoverCard}
            onClosehoverCard={onClosehoverCard}
            onFilter={onFilter}
            onFilterReset={onReset("orderBy=start_time&direction=DESC")}
          />
        )}

        <div className="contentAllSiteWithoutOnglet">
          <section className="columnsWithoutOngletForArray">
            <section className="arrays">
              {!Lodash.isEmpty(explorerData) && !!explorerData && (
                <section className="arraysHeader">
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "10%" }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>
                          {i18next.t("identifiant")}
                        </p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "16%" }}
                    onMouseLeave={onClose}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos" onClick={onOpen(0)}>
                        <p>{i18next.t("date")}</p>
                        <Styled.IconRotate
                          rotates={filterHeader[0]}
                          style={{ width: "8px", right: "-15px" }}
                        >
                          <StyledIcon arrow={true} />
                        </Styled.IconRotate>
                      </div>
                    </div>
                    <div className="styleDivSort">
                      <Styled.BreadBoxContainer
                        isVisible={filter[0]}
                        style={{
                          color: "black",
                          width: "120px",
                          top: "0",
                          margin: "0 auto",
                          position: "relative",
                        }}
                      >
                        <Sorting
                          dateBoolean={true}
                          onSortingAZ={onSortingBy(
                            "orderBy=start_time&direction=ASC"
                          )}
                          onSortingZA={onSortingBy(
                            "orderBy=start_time&direction=DESC"
                          )}
                        />
                      </Styled.BreadBoxContainer>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "11%" }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>
                          {" "}
                          {i18next.t("voie")}
                        </p>
                      </div>
                    </div>
                  </span>

                  {SYSTEMVIEWTUBES && (
                    <span
                      className="arraysHeaderSpanAuto"
                      style={{ width: "12%" }}
                      onMouseLeave={onClose}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(1)}>
                          <p>{i18next.t("tube")}</p>
                          <Styled.IconRotate
                            rotates={filterHeader[1]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.IconRotate>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[1]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=section_name&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=section_name&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                  )}

                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "10%" }}
                    onMouseLeave={onClose}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos" onClick={onOpen(2)}>
                        <p>{i18next.t("camera")}</p>
                        <Styled.IconRotate
                          rotates={filterHeader[2]}
                          style={{ width: "8px", right: "-15px" }}
                        >
                          <StyledIcon arrow={true} />
                        </Styled.IconRotate>
                      </div>
                    </div>
                    <div className="styleDivSort">
                      <Styled.BreadBoxContainer
                        isVisible={filter[2]}
                        style={{
                          color: "black",
                          width: "120px",
                          top: "0",
                          margin: "0 auto",
                          position: "relative",
                        }}
                      >
                        <Sorting
                          onSortingAZ={onSortingBy(
                            "orderBy=camera_code&direction=ASC"
                          )}
                          onSortingZA={onSortingBy(
                            "orderBy=camera_code&direction=DESC"
                          )}
                        />
                      </Styled.BreadBoxContainer>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "10%" }}
                    onMouseLeave={onClose}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos" onClick={onOpen(3)}>
                        <p>{i18next.t("incidents")}</p>
                        <Styled.IconRotate
                          rotates={filterHeader[3]}
                          style={{ width: "8px", right: "-15px" }}
                        >
                          <StyledIcon arrow={true} />
                        </Styled.IconRotate>
                      </div>
                    </div>
                    <div className="styleDivSort">
                      <Styled.BreadBoxContainer
                        isVisible={filter[3]}
                        style={{
                          color: "black",
                          width: "120px",
                          top: "0",
                          margin: "0 auto",
                          position: "relative",
                        }}
                      >
                        <Sorting
                          onSortingAZ={onSortingBy(
                            "orderBy=label_fr&direction=ASC"
                          )}
                          onSortingZA={onSortingBy(
                            "orderBy=label_fr&direction=DESC"
                          )}
                        />
                      </Styled.BreadBoxContainer>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "10%" }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>
                          {" "}
                          {i18next.t("duree")}
                        </p>
                      </div>
                    </div>
                  </span>

                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "11%" }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>
                          {" "}
                          {i18next.t("qualification")}
                        </p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{ width: "10%" }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }} />
                      </div>
                    </div>
                  </span>
                </section>
              )}
              {totalElements !== 0 && itemsPerPage && !noIncidents && (
                <VirtualPagination
                  key={"explorerKey"}
                  classnames="incident-items " // la classe
                  width="100%" //
                  heightView="100%" // hauteur et largeur de la fenètre
                  rowHeight={53} // Hauteur de la cellule
                  arrayContent={!Lodash.isEmpty(explorerData)} // Boolean vérifie si le tableau est vide
                  rowRenderer={rowRenderer} // élement JSX , column
                  itemPerPage={itemsPerPage} // nombre d'élement par page
                  totalItemLength={totalElements} // nombre total d'élement
                  currentPageNumbers={currentPageNumbers} // la page courante
                  onUpdateCurrentPageNumbers={onUpdateCurrentPageNumber} // function de mise à jour de la page courante
                  itemPerRow={1}
                  incident={true}
                  onUpdateScrollTop={onUpdateScrollTop}
                  totalRowElements={explorerData.length}
                  widthView="100%" //
                />
              )}
              {noIncidents && <VirtualLoader />}
            </section>
          </section>
        </div>
      </section>

      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorSearchIncident}
        someTextSuccees={i18next.t("impossible de trouver l'incident")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorExtractionPdf}
        someTextSuccees={i18next.t("impossible d'extraire le pdf")}
      />
    </LayoutGrid>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  totalElements?: any;
  itemsPerPage?: any;
  onUpdateCurrentPageNumber?: any;
  currentPageNumbers?: any;
  loading?: boolean;
  errorserver?: boolean;
  explorerData?: any;
  onClose?: any;
  onOpen?: any;
  filterHeader?: any;
  filter?: any;
  onSortingBy?: any;
  onTextOver?: any;
  alarmOver?: any;
  startTimeOver?: any;
  sectionOver?: any;
  arrayOfIncident?: any;
  onIncidentActif?: any;
  onExtractImpact?: any;
  onExtractVideo?: any;
  errorExtractionVideo?: boolean;
  errorExtractionPdf?: boolean;
  onDeletedSimulation?: any;
  onPenSearchIncidents?: any;
  onOpenhoverCard?: any;
  openHoverCard?: boolean;
  onClosehoverCard?: any;
  onFilter?: any;
  onReset?: any;
  onpensearchboolean?: boolean;
  actionloading?: any;
  // explore search
  explorersearch?: any;
  onExplorerSearch?: any;
  onExplorerSearchChange?: any;
  onPenSearchIncidentsClose?: any;
  onUpdateScrollTop?: any;

  //
  selectedValueName?: any;
  onGetValue?: any;
  endDate?: any; // ok
  QualificationState?: any; // ok
  onSearchQualification?: any;
  qualification?: any;
  onEndDateChange?: any; // ok
  startDate?: any; // ok
  onStartDateChange?: any; // ok
  isFilter?: any; // ok
  errorDateRange?: any;
  sectionSearch?: any;
  cameraSearch?: any;
  labelSearch?: any;
  cameraFilter?: any;
  sectionFilter?: any;
  labelFilter?: any;
  onSearchFilterCamera?: any; // ok
  onSearchFilterLabel?: any;
  onSearchFilterSection?: any;
  onSearchSubmitFilter?: any;
  section?: any;
  cameraList?: any;
  incidentTypeList?: any;
  errorSearchIncident?: any;
  paramArray?: number;
  noIncidents?: boolean;
  onClearIncidentSearch?: any;
}

/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/explorer/home/component.tsx